import { Checkbox, Table } from "antd";
import { ColumnsType } from "antd/lib/table/interface";
import React, { useState } from "react";

type Props = {
  newRows: any[];
  columns: any[];
  onCheckedHeader?: (checked: boolean) => void;
};

const ExcelTablePreview = ({ newRows, columns, onCheckedHeader }: Props) => {
  const [displayData, setDisplayData] = useState(newRows);
  const [pageSize, setPageSize] = useState(10);
  const previewColumn: ColumnsType<any> = columns
    .filter((e) => e.key !== "operation")
    .map((e) => {
      if (!e.template) return e;
      const type = e.template.type;
      const attribute = e.template.attribute;
      if (type === "c") {
        return {
          ...e,
          render: (rowData) => {
            if (!rowData) return "";

            return Number(rowData.replaceAll(",", "")).toLocaleString(
              undefined,
              {
                minimumFractionDigits: Number(
                  attribute.decimal.replaceAll(",", "")
                ),
              }
            );
          },
          template: undefined,
        };
      } else {
        return { ...e, template: undefined };
      }
    });

  return (
    <>
      <Table
        dataSource={displayData}
        columns={previewColumn}
        scroll={{ x: 1500 - 1000, y: 500 }}
        pagination={{
          pageSize: pageSize,
          onShowSizeChange: (current, size) => {
            setPageSize(size);
          },
        }}
      />
    </>
  );
};

export default ExcelTablePreview;
